// extracted by mini-css-extract-plugin
export default {"OtpBoxContainer":"EnterOTPScreen_OtpBoxContainer__gZPWI","Buttons":"EnterOTPScreen_Buttons__szEkj","Title":"EnterOTPScreen_Title__+RPMC"};